export default function getMetaEnv(name, defaultValue = null, attribute = "name") {
  const meta = document.querySelector(`meta[${attribute}="${name}"]`);
  return meta ? meta.content : defaultValue;
}
